var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.circular ? 'v-avatar' : 'span',_vm._b({tag:"vAvatar",class:{
    'mr-3': _vm.left,
    'ml-3': _vm.right,
    'elevation-2': _vm.circular,
    'flag-icon': !_vm.circular,
},style:('background-image: url(' + _vm.flagsPath + _vm.flag + ')')},'vAvatar',{ size: 24, ..._vm.$attrs },false))
}
var staticRenderFns = []

export { render, staticRenderFns }